"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarColorSwitcher = void 0;
var react_1 = __importStar(require("react"));
var carColorSwiper_module_scss_1 = __importDefault(require("./carColorSwiper.module.scss"));
var CarColorSwitcher = function (_a) {
    var carColors = _a.carColors, brand = _a.brand, model = _a.model;
    var _b = (0, react_1.useState)(0), colorIndex = _b[0], setColorIndex = _b[1];
    var handleChangeCarColor = function (value) {
        setColorIndex(value);
    };
    return (react_1.default.createElement("div", { className: carColorSwiper_module_scss_1.default.color_switcher__section },
        react_1.default.createElement("div", { className: carColorSwiper_module_scss_1.default.color_switcher__samples_container },
            react_1.default.createElement("div", { className: carColorSwiper_module_scss_1.default.color_switcher__img },
                react_1.default.createElement("img", { loading: "lazy", src: carColors[colorIndex].image, alt: "".concat(brand, " ").concat(model), title: "".concat(brand, " ").concat(model) })),
            react_1.default.createElement("div", { className: carColorSwiper_module_scss_1.default.color_switcher__color_samples_container }, carColors.map(function (color, index) {
                return (react_1.default.createElement("button", { key: color.id, onClick: function () {
                        handleChangeCarColor(index);
                    }, className: "".concat(carColorSwiper_module_scss_1.default.color_switcher__color_sample, " ").concat(colorIndex === index ? carColorSwiper_module_scss_1.default.active : ''), style: { background: color.background } }));
            })),
            react_1.default.createElement("div", { className: carColorSwiper_module_scss_1.default.color_switcher__current_color },
                "\u0412\u044B\u0431\u0440\u0430\u043D \u0446\u0432\u0435\u0442: ",
                react_1.default.createElement("span", null, carColors[colorIndex].name)))));
};
exports.CarColorSwitcher = CarColorSwitcher;
exports.default = exports.CarColorSwitcher;
